module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.css
// module id = ./src/app/footer/footer.component.css
// module chunks = main